import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import HorizonField from "./HorizonField";
import MicrosoftButton from "./MicrosoftButton";

export default function LoginPage({ onSignIn, loading = false }) {
  const theme = useTheme();
  const pv = theme.vars.palette.login; // only for gradient template strings

  const styles = {
    root: {
      position: "relative",
      width: "100vw",
      height: "100vh",
      minHeight: "640px",
      overflow: "hidden",
      bgcolor: "login.background",
      backgroundImage: [
        `radial-gradient(1100px 700px at 88% 12%, ${pv.gradientCyan}, transparent 60%)`,
        `radial-gradient(900px 600px at 10% 96%, ${pv.gradientBlue}, transparent 55%)`,
      ].join(", "),
    },
    content: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "640px",
      maxWidth: "90%",
      height: "100%",
      padding: "48px 40px 48px clamp(40px, 7vw, 104px)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    eyebrow: {
      fontFamily: "'IBM Plex Mono', 'SF Mono', Consolas, monospace",
      fontSize: "12px",
      letterSpacing: "0.24em",
      textTransform: "uppercase",
      color: "login.eyebrow",
      mb: "30px",
    },
    headingSecondary: {
      fontFamily: "'Poppins', system-ui, sans-serif",
      fontWeight: 500,
      fontSize: "30px",
      color: "login.headingSecondary",
      letterSpacing: "0.01em",
      lineHeight: 1,
    },
    headingPrimary: {
      fontFamily: "'Poppins', system-ui, sans-serif",
      fontWeight: 700,
      fontSize: "clamp(56px, 8vw, 88px)",
      color: "login.heading",
      letterSpacing: "-0.03em",
      lineHeight: 0.98,
      mt: "4px",
    },
    accentBar: {
      width: "56px",
      height: "4px",
      borderRadius: "2px",
      bgcolor: "login.accent",
      mt: "30px",
      mb: "26px",
    },
    bodyText: {
      fontFamily: "'Figtree', system-ui, sans-serif",
      fontSize: "18px",
      lineHeight: 1.55,
      color: "login.body",
      maxWidth: "380px",
    },
    buttonWrapper: {
      width: "380px",
      maxWidth: "100%",
      mt: "42px",
    },
    loadingSpinner: {
      display: "flex",
      justifyContent: "center",
      py: 2,
    },
    footer: {
      fontFamily: "'Figtree', system-ui, sans-serif",
      fontSize: "13px",
      color: "login.footer",
      letterSpacing: "0.01em",
      mt: "40px",
    },
  };

  return (
    <Box sx={styles.root}>
      <HorizonField />

      <Box sx={styles.content}>
        <Box sx={styles.eyebrow}>Internal planning workspace</Box>

        <Typography variant="div" component="div" sx={styles.headingSecondary}>
          VeroSource
        </Typography>
        <Typography variant="div" component="div" sx={styles.headingPrimary}>
          Roadmap
        </Typography>

        <Box sx={styles.accentBar} />

        <Typography variant="div" component="p" sx={styles.bodyText}>
          Plan and track initiatives across every horizon. Use your VeroSource
          account to continue.
        </Typography>

        <Box sx={styles.buttonWrapper}>
          {loading ? (
            <Box sx={styles.loadingSpinner}>
              <CircularProgress size={32} />
            </Box>
          ) : (
            <MicrosoftButton onClick={onSignIn} />
          )}
        </Box>

        <Box sx={styles.footer}>Internal access only · VeroSource © 2026</Box>
      </Box>
    </Box>
  );
}
